import { createEvent, restore, sample } from 'effector'
import { CreatePromoCode, CreatePromoCodePayload } from './types'
import { fx, path } from '../../../../libs'
import { toPath } from '../../../../features/router'
import {
  setRequestError,
  setRequestSuccess,
} from '../../../../features/notifications'

export const setPromoCode = createEvent<CreatePromoCode>()

export const submitCreatePromoCode = createEvent<CreatePromoCodePayload>()

export const $promoCode = restore(setPromoCode, {
  code: '',
  bonusPercent: '',
  expiresAt: '',
  userId: '',
})

export const createPromoCode = fx<CreatePromoCodePayload, void>({
  method: 'POST',
  url: '/deposit_bonus/promo_code',
})

sample({
  clock: submitCreatePromoCode,
  fn: (promoCode) => {
    return {
      url: `/deposit_bonus/promo_code`,
      body: { ...promoCode },
    }
  },
  target: createPromoCode,
})

sample({
  clock: createPromoCode.doneData,
  fn: () => true,
  target: setRequestSuccess,
})

sample({
  clock: createPromoCode.doneData,
  target: toPath.prepend(path.depositBonus.promoCodes.entry),
})

sample({
  clock: createPromoCode.failData,
  fn: (failData: any) => ({
    message:
      failData?.body?.message || failData?.message || 'Unknown error',
    code: failData?.status ?? 0,
  }),
  target: setRequestError,
})
